import { GridFooterView } from '../view/GridFooterView';
import { templateGridFooter } from '../view/template';
import { BaseWebComponentController } from '../../../framework/BaseWebComponentController';
import { GridFooterWebComponent } from '..';
import { GridFooterWebComponentSchema } from '../types';
import { GridEvents } from '../../types/common';
import { State as GridSummaryState } from '../../uiElements/gridSummary/types';

export class GridFooterController extends BaseWebComponentController {
  public component: GridFooterWebComponent;
  public view: GridFooterView;
  public viewConstructor: typeof GridFooterView;

  private static dispatchEvent(element: HTMLElement, event: GridEvents, data?: Object) {
    if (!data) {
      data = {};
    }

    element.dispatchEvent(
      new CustomEvent(event, {
        detail: data,
        bubbles: true,
        composed: true,
      })
    );
  }

  constructor(component: GridFooterWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: GridFooterView,
      viewTemplate: templateGridFooter,
    });
  }

  computeEventListeners() {
    return [
      {
        element: this.view.dom.$loadMore,
        event: 'click',
        callback: () => {
          return GridFooterController.dispatchEvent(this.view.dom.$loadMore, GridEvents.LOAD_MORE_ROWS, {
            numRecordsToFetch: this.view.getPageSize(),
          });
        },
      },
      {
        element: this.view.dom.$gridDataRefresh,
        event: 'click',
        callback: () =>
          GridFooterController.dispatchEvent(this.view.dom.$gridDataRefresh, GridEvents.REFRESH_DATA_FROM_FOOTER),
      },
      {
        element: this.view.dom.$backToTop,
        event: 'click',
        callback: () => GridFooterController.dispatchEvent(this.view.dom.$backToTop, GridEvents.BACK_TO_TOP),
      },
      {
        element: this.view.dom.$loadItemsCount,
        event: 'selectionChanged',
        callback: event => {
          const loadItemsCount = event.detail.value;
          const pageSize = parseInt(loadItemsCount, 10);

          return GridFooterController.dispatchEvent(this.view.dom.$loadItemsCount, GridEvents.SET_PAGE_SIZE, {
            pageSize: pageSize,
          });
        },
      },
      {
        element: this.view.dom.$paginationFooter,
        event: GridEvents.SET_PAGE_NUMBER,
        callback: event => {
          this.component.pageNumber = event.detail.pageNumber;
        },
      },
      {
        element: this.view.dom.$paginationFooter,
        event: GridEvents.SET_PAGE_SIZE,
        callback: event => {
          this.component.pageSize = event.detail.pageSize;
        },
      },
      {
        element: this.view.dom.$loadItemsCount,
        event: GridEvents.SET_PAGE_SIZE,
        callback: event => {
          this.component.pageSize = event.detail.pageSize;
        },
      },
    ];
  }

  async getDataForView(): Promise<GridFooterWebComponentSchema> {
    return {
      pageSize: this.component.pageSize,
      pageNumber: this.component.pageNumber,
      hasPagination: this.component.hasPagination,
      hideGridRefresh: this.component.hideGridRefresh,
      numSelectedItems: this.component.numSelectedItems,
      numTotalItems: this.component.numTotalItems,
      numTotalPages: this.component.numTotalPages,
      pageSizeOptions: this.component.pageSizeOptions,
      gridSummary: this.component.gridSummary,
    };
  }

  public setDisabledLoadMore(disabled: boolean) {
    this.view.setDisabledLoadMore(disabled);
  }

  public setDisabledForFetchingDataButtons(disabled: boolean) {
    if (this.component.hasPagination) {
      this.view.dom.$paginationFooter.isDisabled = disabled;
    } else {
      this.setDisabledLoadMore(disabled);
    }
  }

  public updateGridSummaryState(state: GridSummaryState | null) {
    this.view.dom.$gridSummary.state = state;
  }
}
